import { useState } from "react";
import type { FormEvent } from "react";

import { useDialogForm, useToast } from "@/ds";
import { definirCotacaoObra } from "@/modules/financeiro-obras";
import { useChaveIdempotencia } from "@/shared/hooks";
import {
  COTACAO_DEFINIDA_MESSAGE,
  COTACAO_FORM_ID,
  COTACAO_MAIOR_QUE_ZERO,
  COTACAO_OBRIGATORIA,
} from "./cotacao-dialog.constants";
import type { CotacaoDialogProps } from "./types-cotacao-dialog";

type CotacaoForm = { cotacao: number | null };

function validarCotacao(cotacao: number | null): string | null {
  if (cotacao === null) return COTACAO_OBRIGATORIA;
  return cotacao > 0 ? null : COTACAO_MAIOR_QUE_ZERO;
}

export function useCotacaoDialog({ obraId, moeda, onClose, onDefinida }: CotacaoDialogProps) {
  const toast = useToast();
  const { comChave } = useChaveIdempotencia();
  const [foco, setFoco] = useState(0);

  const form = useDialogForm<CotacaoForm>({
    initial: { cotacao: null },
    validate: ({ cotacao }) => {
      const erro = validarCotacao(cotacao);
      return erro ? { cotacao: erro } : {};
    },
    onSubmit: async ({ cotacao }) => {
      const body = { moedaId: moeda.id, cotacao: cotacao as number };
      const definida = await comChave(body, (idempotencyKey) =>
        definirCotacaoObra(obraId, body, { idempotencyKey }),
      );
      toast.success(COTACAO_DEFINIDA_MESSAGE(moeda.codigo));
      onDefinida(definida);
    },
  });

  return {
    formId: COTACAO_FORM_ID,
    moedaCodigo: moeda.codigo,
    cotacao: form.values.cotacao,
    cotacaoError: form.errors.cotacao ?? null,
    foco,
    isSubmitting: form.isSubmitting,
    submitError: form.submitError,
    digitarCotacao: (valor: number | null) => form.setValue("cotacao", valor),
    enviar: (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (validarCotacao(form.values.cotacao)) setFoco((atual) => atual + 1);
      void form.submit();
    },
    cancelar: onClose,
  };
}
